<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.clients')">
          <form ref="form">
            <input id="client-id" type="hidden" v-model="client.id" />
            
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.name" placeholder="Nome"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.trading_name" placeholder="Nome Comercial"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.address" placeholder="Endereço"/>
              </div>
            </div>

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.district" placeholder="Bairro"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.city" placeholder="Cidade"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.state" placeholder="Estado"/>
              </div>
            </div>

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.zip_code" placeholder="CEP"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.latitude" placeholder="Latitude"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.longitude" placeholder="Longitude"/>
              </div>
            </div>

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input 
                  v-model="client.start_of_service"
                  placeholder="Início do Serviço 00:00"
                  v-mask="maskTime"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input 
                  v-model="client.end_of_service"
                  placeholder="Fim do Serviço 00:00"
                  v-mask="maskTime"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="client.cpf_cnpj" placeholder="CPF/CNPJ"/>
              </div>
            </div>

            <div class="row">
              <div class="flex xs12 sm3">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="save(client)">
                  {{ $t('menu.save') }}
                </va-button>

                <BackButton />
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from '../shared/BackButton'
import { http } from "@/services/config";
import { showError } from '@/global'
import moment from 'moment'

export default {
  components: { BackButton },
  data(){
    return {
      client: {
       name: '',
       trading_name: '',
       address: '',
       district: '',
       city: '',
       state: '',
       zip_code: '',
       latitude: '',
       longitude: '',
       start_of_service: '',
       end_of_service: '',
       cpf_cnpj: ''
      },
      maskTime: '##:##',
    }
  },

  mounted(){
    this.getClient()
  },

  filters: {
    formatTimeToHour: function (value) {
      if (!value) return ''
      value = value.toString()
      return moment(String(value)).format('hh:mm')
    }
  },

  methods: {
    getClient(){
      if (this.$route.params.id != undefined){
        http.get(`/clients/${this.$route.params.id}`).then(response => {
          let res = response.data["client"].start_of_service
          console.log(res | this.formatTimeToHour)
          this.client = response.data["client"]
        }).catch(e => showError(e))
      }
    },
    
    save() {
      if (this.client.id) {
        http.put(`/clients/${this.client.id}`, this.client).then(() => {
          this.$toasted.global.defaultSuccess()
          this.$router.push({ name: "clients" })
        }).catch(e => showError(e));
      } else {
        http.post(`/clients`, this.client).then(() => {
          this.$toasted.global.defaultSuccess()
          this.$router.push({ name: "clients" })
        }).catch(e => showError(e));
      }
    },
  }

}
</script>

<style>

</style>